import clsx from 'clsx';
import React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

import { AssetManagerIcon, AuthorsIcon, CollectionsIcon, TemplatesIcon } from '@cms/components/icons';
import { SystemTooltip } from '@cms/components/ui/Tooltip';
import { AssetsPath, CollectionsPath, TemplatesPath, UsersPath } from '@cms/utils/routes';

import { IoIosArrowUp } from 'react-icons/io';

type SpeedDialLinkProps = {
    icon: React.ReactNode;
} & Pick<LinkProps, "to" | "onClick" | "title" | "className">

const SpeedDialLink: React.FC<SpeedDialLinkProps> = (props) => {
    const { icon, title, to, onClick, className = '' } = props;

    return (
        <Link
            className={clsx(
                "absolute left-1/2 -translate-x-1/2 h-12 w-12 flex justify-center items-center rounded-full text-white bg-cs-900 transition-all duration-300",
                "opacity-0 scale-75 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto",
                className
            )}
            style={{ transitionProperty: 'top, opacity, transform' }}
            to={to}
            onClick={onClick}
        >
            <SystemTooltip
                message={title}
            >
                <div>
                    {icon}
                </div>
            </SystemTooltip>
        </Link>
    )
}

const BurgerMenuButton = () => {
    return (
        <button
            className="cursor-pointer absolute left-1/2 top-[180px] -translate-x-1/2 h-14 w-14 select-none flex justify-center items-center text-white bg-cs-900 rounded-full shadow"
            type="button"
            style={{ transitionProperty: 'box-shadow' }}
        >
            <span
                className="absolute left-1/2 top-1/2 w-7 h-0.5 bg-white rounded transition-all duration-300 origin-center -translate-x-1/2 -translate-y-[9px] group-hover:rotate-45 group-hover:translate-y-0"
            />
            <span
                className="absolute left-1/2 top-1/2 w-7 h-0.5 bg-white rounded transition-all duration-300 origin-center -translate-x-1/2 -translate-y-1/2 group-hover:opacity-0"
            />
            <span
                className="absolute left-1/2 top-1/2 w-7 h-0.5 bg-white rounded transition-all duration-300 origin-center -translate-x-1/2 translate-y-[7px] group-hover:-rotate-45 group-hover:translate-y-0"
            />
        </button>
    )
}

export const EditorSpeedDial = () => {
    const location = useLocation();

    const handleGoToTheTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <div className="z-40 w-fit sticky bottom-2/5 left-full -translate-x-full">
            <div className="group relative flex flex-col items-center justify-center h-[300px] w-14">
                <SpeedDialLink
                    title='Go to top'
                    to={location}
                    icon={<IoIosArrowUp size={24} />}
                    className='top-[100px] group-hover:top-0 bg-cs-600!'
                    onClick={handleGoToTheTop}
                />

                <SpeedDialLink
                    title='Templates'
                    to={{ pathname: TemplatesPath }}
                    icon={<TemplatesIcon />}
                    className='top-[100px] group-hover:top-[120px]'
                />

                <SpeedDialLink
                    title='Assets manager'
                    to={{ pathname: AssetsPath }}
                    icon={<AssetManagerIcon />}
                    className='top-[100px] group-hover:top-[60px]'
                />

                <BurgerMenuButton />


                <SpeedDialLink
                    title='Authors'
                    to={{ pathname: UsersPath, search: '?role=author' }}
                    icon={<AuthorsIcon />}
                    className='top-[100px] group-hover:top-60'
                />
                <SpeedDialLink
                    title='Collections'
                    to={{ pathname: CollectionsPath }}
                    icon={<CollectionsIcon />}
                    className='top-[100px] group-hover:top-[300px]'
                />
            </div>
        </div>
    )
}
